export const GET_ASSET_TEMPLATES_BY_CATEGORY =
  'estatePlan/GET_ASSET_TEMPLATES_BY_CATEGORY';
